import React, { useState, useCallback } from 'react';
import ConfirmModal from '../ConfirmModal';

// Drop-in for window.confirm that looks right on phones.
//   const [confirm, confirmDialog] = useConfirm();
//   if (!(await confirm('Delete this?'))) return;
//   ...render {confirmDialog} once in the component.
const useConfirm = () => {
  const [state, setState] = useState(null);

  const confirm = useCallback((message, { title = 'Are you sure?', confirmText = 'Confirm' } = {}) =>
    new Promise((resolve) => setState({ message, title, confirmText, resolve })), []);

  const finish = (answer) => {
    state?.resolve(answer);
    setState(null);
  };

  const dialog = (
    <ConfirmModal
      isOpen={Boolean(state)}
      onClose={() => finish(false)}
      onConfirm={() => finish(true)}
      title={state?.title}
      message={state?.message}
      confirmText={state?.confirmText}
    />
  );

  return [confirm, dialog];
};

export default useConfirm;
